import Vue from 'vue'
import VueTree from '@ssthouse/vue-tree-chart'
 
Vue.use(VueTree)

export default VueTree